import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, CheckCircle2, Monitor } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const msg = (e, fb) => { const d = e?.response?.data?.detail; return (d && (d.message || d)) || fb; };

// /approve?c=CODE — a phone already signed in to OL (by its personal link) approves a family computer.
// Scanning the computer's QR lands here with the code filled in.
export default function ApproveComputerPage() {
  const [code, setCode] = useState(new URLSearchParams(window.location.search).get('c') || '');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');
  const go = async () => {
    setBusy(true); setErr('');
    try { await axios.post(`${API_URL}/api/access/approve`, { code }, { withCredentials: true }); setDone(true); }
    catch (e) { setErr(e?.response?.status === 401 ? 'Open your personal link on this phone first, then try again.' : msg(e, 'Could not approve.')); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center p-4" data-testid="approve-computer-page">
      <div className="max-w-sm w-full rounded-xl border bg-white dark:bg-slate-800 dark:border-slate-700 p-6 text-center space-y-3">
        {done ? (<>
          <CheckCircle2 className="h-10 w-10 mx-auto text-emerald-500" />
          <p className="font-semibold">Computer approved</p>
          <p className="text-sm text-slate-500">It signs in by itself in a moment and stays signed in for your family.</p>
        </>) : (<>
          <Monitor className="h-8 w-8 mx-auto text-slate-500" />
          <h1 className="text-lg font-bold">Approve a computer</h1>
          <p className="text-sm text-slate-500">Enter the code shown on the computer.</p>
          <input className="w-full h-12 rounded-lg border text-center text-2xl tracking-widest uppercase dark:bg-slate-700 dark:border-slate-600" value={code} maxLength={9} placeholder="ABCD-1234" onChange={e => setCode(e.target.value.toUpperCase())} data-testid="approve-code" />
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button className="w-full h-12 rounded-lg bg-slate-800 text-white font-semibold flex items-center justify-center gap-2" disabled={busy || code.replace(/[^A-Z0-9]/g, '').length < 8} onClick={go} data-testid="approve-go">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Approve</button>
        </>)}
      </div>
    </div>
  );
}
